module.exports = __webpack_public_path__ + "img/shanghaijunxiu.e0a6d3e8.png";